<style>
.InspectionsTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.InspectionsTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.InspectionsTable .table__container--panel p {
  font-size: 12px;
}
.InspectionsTable .table__container--filter {
  font-size: 12px;
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout class="table--first-row" row wrap>
          <v-flex class="table__wrapper--center">
            <!--<v-icon
              @click="show('addInspectionCardModal')"
              v-if="$can('read', 'inspections_edit')"
              class="table__btn--green"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="show('addInspectionCardModal')"
              v-if="$can('read', 'inspections_edit')"
            >DODAJ PRZEGLĄD</p>
             ---------------------------------------- -->
            <v-icon
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openInspectionCard"
              >note</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="openInspectionCard">
              OTWÓRZ KARTĘ
            </p>
            <!-- ---------------------------------------- -->
            <v-icon
              class="table__btn--blue table__btn--padding"
              style="margin-left: 14px"
              v-show="selectedRow && !hydrant"
              @click="openHydrantCard"
              >note</v-icon
            >
            <p
              class="caption"
              v-show="selectedRow && !hydrant"
              @click="openHydrantCard"
            >
              KARTA HYDRANTU
            </p>
            <!-- ---------------------------------------- -->
            <!-- <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >Usuń</p> -->
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
              class="table__btn--blue"
              >cloud_download</v-icon
            >
            <p
              class="caption"
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
            >
              POBIERZ REJESTR
            </p>
            <!-- ---------------------------------------- -->
            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
              >delete</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="removeRow">USUŃ</p>
            <!-- <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
            >Przybliż</p> -->
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex xs5 class="table__wrapper--center table__wrapper--filter">
        <v-layout align-right justify-end>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <ag-grid-vue
      style="width: 100%; height: 85%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  props: {
    hydrant: {
      type: Number,
      required: false,
      default: null
    },
    last_only: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  data: () => ({
    date_now: new Date(),
    filter: "",
    inspectionsTaskFiltered: undefined,
    numberAll: "0",
    numberFiltered: "0",
    selectedRow: undefined,
    tableTitle: "InspectionsTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    const noDataGetter = val => {
      if (val == null) {
        return "Brak danych";
      } else if (!val) {
        return "Nie sprawdzono";
      } else {
        return "Sprawdzono";
      }
    };
    this.columnDefs = [
      { headerName: "ID", field: "id", sort: "asc", width: 80 },
      {
        headerName: "Data przeglądu",
        field: "inspection_date",
        valueGetter: val => {
          if (val.data.inspection_date != null) {
            return new Date(val.data.inspection_date).toLocaleString("pl-PL", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            });
          }
        }
      },
      { headerName: "Użytkownik", field: "username" },
      {
        headerName: "Wartość ciśnienia statycznego",
        field: "static_pressure_value"
      },
      {
        headerName: "Wartość ciśnienia dynamicznego",
        field: "dynamic_pressure_value"
      },
      {
        headerName: "Wartość natężenia wypływu",
        field: "flow_rate_value"
      },
      {
        headerName: "Oględziny zewnętrzne",
        field: "external_examination",
        valueGetter: val => noDataGetter(val.data.external_examination)
      },
      {
        headerName: "Uruchomienie/przepłukanie hydrantu",
        field: "startup",
        valueGetter: val => noDataGetter(val.data.startup)
      },
      {
        headerName: "Ciśnienie statyczne",
        field: "static_pressure",
        valueGetter: val => noDataGetter(val.data.static_pressure)
      },
      {
        headerName: "Ciśnienie dynamiczne",
        field: "dynamic_pressure",
        valueGetter: val => noDataGetter(val.data.dynamic_pressure)
      },
      {
        headerName: "Natężenie wypływu",
        field: "flow_rate",
        valueGetter: val => noDataGetter(val.data.flow_rate)
      },
      {
        headerName: "Odwodnienie",
        field: "abduction",
        valueGetter: val => noDataGetter(val.data.abduction)
      },
      { headerName: "Komentarze", field: "comments" },
      { headerName: "Hydrant", field: "hydrant" }
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    },
    openHydrantCard() {
      let payload = {
        object_id: this.selectedRow.hydrant,
        object_table: "hydrants",
        object_type: "layers",
        limit: 5,
        events_count: true
      };
      this.$root.$emit("setInspectionDates", this.selectedRow.inspection_date);
      this.$store.dispatch("getFeature", payload).then(success => {
        this.$store.commit("setHydrantData", success);
        if (success) {
          this.$root.$emit("loadHydrantData", success);
          this.$store.dispatch("getFeatureEvents", payload).then(r => {
            if (r) {
              this.show("hydrantCardModal");
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas pobierania danych hydrantu wystąpił błąd"
              );
            }
          });
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych hydrantu wystąpił błąd"
          );
        }
      });
    },
    openInspectionCard() {
      /// tymczasowe zamaskowanie problemu z eventami
      if (this.activeModals.includes("inspectionCardModal")) {
        this.$modal.hide("inspectionCardModal");
      }
      ///
      let payload = {
        object_id: this.selectedRow.id,
        object_table: "inspections",
        limit: 5,
        events_count: true,
        isInspection: true
      };
      this.$root.$emit("loadHydrantInspection", this.selectedRow);
      this.$store.dispatch("getFeatureEvents", payload).then(r => {
        this.$root.$emit("setInspection", r);
        this.show("inspectionCardModal");
      });
    },
    removeRow() {
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie karty przeglądu",
        text: "Czy na pewno chcesz usunąć kartę przeglądu?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch("removeInspectionCard", this.selectedRow.id)
                .then(r => {
                  if (r === true) {
                    this.loadData();
                  } else {
                    this.$root.$emit("showSnackbar", "red", `${r}`);
                  }
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    loadData() {
      this.$store
        .dispatch("getInspectionCards", {
          hydrant: this.hydrant,
          last_only: this.last_only
        })
        .then(r => {
          if (r) {
            this.numberAll = r.inspections.length;
            this.numberFiltered = this.numberAll;
            this.gridOptions.api.setRowData(r.inspections);
          }
        });
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
      this.$root.$emit("removeMapLayer");
    }
  },
  mounted() {
    this.$root.$on("edited_inspection", this.loadData);
    this.$on("removeFilters", this.removeFilters);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/InspectionsTable.vue